var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroupBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC801",
    d: "M16.522 13.334c0-.46-.39-.833-.87-.833L.87 8C.39 8 0 8.374 0 8.834v10.334c0 .46.39.833.87.833h14.782c.48 0 .87-.373.87-.833v-5.834ZM19.13 12.668h-.87c.481 0 .87.373.87.833v5.667c0 .46-.389.833-.87.833h.87c.48 0 .87-.373.87-.833V13.5c0-.46-.39-.833-.87-.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC801",
    d: "M18.26 13.5c0-.46-.389-.833-.869-.833h-.87c.48 0 .87.373.87.833v5.668c0 .46-.39.833-.87.833h.87c.48 0 .87-.373.87-.833V13.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC801",
    fillRule: "evenodd",
    d: "M9.504.132a1 1 0 0 1 .992 0l7 4A1 1 0 0 1 17 6v5.859l-2.03-.614A1 1 0 0 0 15 11V8a1 1 0 1 0-2 0v2.648l-2-.605V8a1 1 0 1 0-2 0v1.437l-2-.605V8a1 1 0 0 0-2 0v.227L3 7.62v-1.62a1 1 0 0 1-.496-1.87l7-4Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupBuildings);
export default ForwardRef;